import type { UnwrapNestedRefs } from "vue";
import { ref, reactive, computed, watch, onUnmounted } from "vue";
import type { Ref, ComputedRef } from "vue";
import { findIndex, sortBy, throttle } from "lodash";
import type { DataTableColumnType, UseSelectionType } from "../types";

interface TablePropsType {
  rowKey: any;
  data: any[];
  selectable(row:any,i:number):boolean;
}
export function useSelection(
  props: TablePropsType,
  ctx: any
): UseSelectionType {
  const selections: UnwrapNestedRefs<any[]> = reactive<any[]>([]);
  const isSelected = (row: any) => row.__selected;

  const toggleSelection = throttle(
    (row: any) => {
      if (isSelected(row)) {
        row.__selected = false;
        selections.splice(selections.indexOf(row), 1);
      } else {
        row.__selected = true;
        selections.push(row);
      }
      ctx.emit("selection-change", selections);
    },
    500,
    {
      leading: true,
      trailing: false,
    }
  );
  const clearSelection = () => {
    selections.splice(0, selections.length);
    ctx.emit("selection-change", selections);
  };

  const toggleAllSelection = throttle(
    () => {
      if (isAllSelected.value) {
        deselectAll();
      } else {
        selectAll();
      }
      ctx.emit("selection-change", selections);
    },
    500,
    {
      leading: true,
      trailing: false,
    }
  );
  const selectAll = () => {
    selections.length = 0;
    props.data.filter((o,i)=>typeof props.selectable=='function'?props.selectable(o,i):true).map((o, i) => {
      
      props.data[i].__selected = true;
      selections.push(o);
    });
  };
  const deselectAll = () => {
    selections.map((o, i) => {
      props.data[i].__selected = false;
    });
    selections.length = 0;
  };
  const isAllSelected = computed(() => {
    if (selections.length === 0) {
      return false;
    }
    const uniqueKeys = new Set(selections.map((row) => getKey(row)));
    return (
      props.data.length > 0 &&
      props.data.every((row) => uniqueKeys.has(getKey(row)))
    );
  });

  function getKey(row: any) {
    if (typeof props.rowKey === "function") {
      return props.rowKey(row);
    } else if (
      typeof props.rowKey === "string" &&
      typeof row[props.rowKey] != "undefined"
    ) {
      return row[props.rowKey];
    } else {
      return row.id;
    }
  }

  onUnmounted(() => {
    clearSelection();
  });

  return {
    selections,
    isSelected,
    toggleAllSelection,
    toggleSelection,
    clearSelection,
    selectAll,
    deselectAll,
    isAllSelected,
  };
}
